import { render, staticRenderFns } from "./ConsumerRespList.vue?vue&type=template&id=6af6eeae&"
import script from "./ConsumerRespList.vue?vue&type=script&lang=js&"
export * from "./ConsumerRespList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports